import {
  FETCH_INVOICE_DATA,
  PRINT_INVOICE,
  SELECT_PAYMENT_METHOD,
  SELECT_PGW,
  USE_WALLET,
  ADD_COMPANION,
  DELETE_COMPANION,
  FETCH_ALL_COMPANION_LIST,
  FETCH_COMPANION_LIST,
  SUBMIT_DISCOUNT,
  UPDATE_COMPANION,
  UPDATE_RESERVE_STATUS,
  REMOVE_DISCOUNT,
  FETCH_GETWAYS_LIST,
  SELECT_PAYMENT_METHOD_GETWAYS,
  FETCH_EDIT_RESERVE_PROFORMA,
  EXPIRED_TIME,
  USE_PRIZE_WALLET,
  SELECT_PAYMENT_WAY,
  SELECT_INSTALLMENT_PAYMENT_METHOD_GETWAYS,
  SNAPP_PAY_ELIGIBLE,
  CHANGE_CANCELLATION_RESERVE_STATUS,
  GET_CANCELLING_RULE,
  SET_CANCELLING_REASON,
  UPDATE_INVOICE_DATA,
  ADD_DISCOUNT,
  DIGI_PAY_ELIGIBLE,
  DIGI_PAY_WALLET_ELIGIBLE,
  CROUSE_ELIGIBLE,
  EWANO_ELIGIBLE,
  ZEECARD_ELIGIBLE,
} from '../actions/types'
import { GetwaysListType } from '../types'

interface GatwaysList {
  title: string
  description: null | string
  id?: number
  default_id?: number
  gateways: Gateway[] | null
}

interface Gateway {
  id: number
  name: string
  description: string
  logo_path: string
  is_installment: number
}

type InitialStates = {
  print: boolean
  activeWallet: boolean
  activePrizeWallet: boolean
  paymentType: string
  pgwType: number
  paymentMethod: null
  gatewaysList: {
    data: GatwaysList[] | Gateway[]
    loading: boolean
  } | null
  expired: boolean
  eligible: { eligible: boolean; description: string } | null
}
const INITIAL_STATES = {
  print: false,
  activeWallet: false,
  activePrizeWallet: false,
  paymentType: 'payByBank',
  pgwType: 1,
  paymentMethod: null,
  installmentPaymentMethod: null,
  gatewaysList: null,
  expired: false,
  paymentWay: { value: 'پرداخت مستقیم آنلاین', id: 1 },
  eligible: null,
}
interface InvoiceReducerType extends InitialStates {
  data: { data: Data | null } | null
  loading: boolean
}

interface Data {
  invoice: Invoice
  house: House
  reservation: Reservation
  participant: Participant
  companions_count: number
  rules: Rules
  issuance_date: string
  expire_at: number
  credit: number
  payment_motivation: null
}

interface Rules {
  accommodates: number
  max_accommodates: number
  checkin: string
  checkout: string
  max_checkin_time: string
  minimum_days: number
  sat_min_days: number
  sun_min_days: number
  mon_min_days: number
  tue_min_days: number
  wed_min_days: number
  thu_min_days: number
  fri_min_days: number
  maximum_days: number
  maximum_days_before_checkin: number
  description: string
  pets: string
  pets_description: string
  ceremony: string
  ceremony_description: string
  documents: string
  cancellation_plan: number
  can_change_date: number
  need_marital_documents: number
  smoking: number
  twenty_four_hour_entry: number
}

interface Participant {
  type: string
  host: Host
  guest: Guest
}

interface Guest {
  name: string
  family: string
  mobile: string
}

interface Host {
  name: string
  family: string
  mobile: null
  profile: string
}

interface Reservation {
  id: string
  house_id: number
  checkin: string
  checkout: string
  checkin_timestamp: number
  checkout_timestamp: number
  days_count: number
  guests_count: number
  extra_person_count: number
  is_instant: number
  status: Status
  last_state: Laststate
  meta: Meta
}

interface Meta {
  sort: null
}

interface Laststate {
  type: string
  title: string
  role: string
  actor: string
}

interface Status {
  type: number
  title: string
}

interface House {
  id: number
  extra_person: number
  thumbnailAbsoluteUrl: string
  title: string
  province: string
  city: string
  address: null
  rooms: number
  detached: number
  accommodates: number
  max_accommodates: number
  rule_checkout: null
  rule_checkin: null
  latitude: null
  longitude: null
  is_instant: boolean
}

interface Invoice {
  all_days: number
  payment: Payment
}

interface Payment {
  days_type: Daystype[]
  person_type: Persontype[]
  simple_type: Simpletype[]
}

export interface Simpletype {
  key: string
  title: string
  final_price: number
  is_discount: boolean
}

interface Persontype {
  key: string
  title: Title2
  final_price: number
}

interface Title2 {
  person_count: number
  price: number
  days_count: number
}

interface Daystype {
  key: string
  title: Title
  final_price: number
}

interface Title {
  day_count: number
  price: number
}

export const invoiceReducer = (
  state: InvoiceReducerType = { data: null, loading: false, ...INITIAL_STATES },
  { type, data, loading },
) => {
  switch (type) {
    case FETCH_INVOICE_DATA:
      return { ...state, data, loading }
    case UPDATE_INVOICE_DATA:
      return { ...state, invoice: data, loading }
    case ADD_DISCOUNT:
      return { ...state, addedDiscount: data }
    case PRINT_INVOICE:
      return { ...state, print: !state.print }
    case USE_WALLET:
      return { ...state, activeWallet: !state.activeWallet }
    case USE_PRIZE_WALLET:
      return { ...state, activePrizeWallet: !state.activePrizeWallet }
    case SELECT_PAYMENT_METHOD:
      return { ...state, paymentType: data }
    case SELECT_PGW:
      return { ...state, pgwType: data }
    case SELECT_PAYMENT_METHOD_GETWAYS:
      return { ...state, paymentMethod: data }
    case SELECT_INSTALLMENT_PAYMENT_METHOD_GETWAYS:
      return { ...state, installmentPaymentMethod: data }
    case SELECT_PAYMENT_WAY:
      return { ...state, paymentWay: data }
    case UPDATE_RESERVE_STATUS:
      return {
        ...state,
        data: {
          ...state,
          data: {
            ...state.data?.data,
            expired_at: data.expiredAt,
            reservation: {
              ...state.data?.data?.reservation,
              last_state: {
                ...state.data?.data?.reservation?.last_state,
                type: data.status,
              },
            },
          },
        },
      }
    case CHANGE_CANCELLATION_RESERVE_STATUS:
      return {
        ...state,
        data: {
          ...state,
          data: {
            ...state.data?.data,
            reservation: {
              ...state.data?.data?.reservation,
              last_state: {
                ...state.data?.data?.reservation?.last_state,
                type: data,
                title: 'کنسل شده',
              },
            },
          },
        },
      }
    case FETCH_GETWAYS_LIST: {
      return {
        ...state,
        gatewaysList: {
          data: data?.data,
          loading,
        },
      }
    }
    case EXPIRED_TIME:
      return { ...state, expired: true }
    case SUBMIT_DISCOUNT:
      return { ...state, discountData: { data, loading } }
    case FETCH_EDIT_RESERVE_PROFORMA:
      return { ...state, editReserveProforma: { data, loading } }
    case SNAPP_PAY_ELIGIBLE:
      return { ...state, eligible: data }
    case CROUSE_ELIGIBLE:
      return { ...state, eligible: data }
    case DIGI_PAY_ELIGIBLE:
      return { ...state, eligible: data }
    case EWANO_ELIGIBLE:
      return { ...state, eligible: data }
    case ZEECARD_ELIGIBLE:
      return { ...state, eligible: data }
    case DIGI_PAY_WALLET_ELIGIBLE:
      return { ...state, eligible: data }
    case GET_CANCELLING_RULE:
      return { ...state, rulesData: data }
    case SET_CANCELLING_REASON:
      return { ...state, cancellingReason: data }
    default:
      return state
  }
}

export interface CompanionListType {
  data: any
  localData: any
  loading: boolean
}

export const companionList = (
  state: CompanionListType = { data: null, loading: false, localData: [] },
  action,
) => {
  switch (action.type) {
    case FETCH_COMPANION_LIST:
      return {
        data: action.data,
        loading: action.loading,
        localData: action.data,
      }
    case ADD_COMPANION:
      return {
        data: state.data,
        loading: action.loading,
        localData: action.data
          ? [...state.localData, action.data]
          : [...state.localData],
      }
    case UPDATE_COMPANION:
      return {
        data: state.data,
        loading: action.loadingloading,
        localData: action.data ? action.data : [...state.localData],
      }
    case DELETE_COMPANION:
      return {
        data: state.data,
        loading: action.loading,
        localData: action.data ? [...action.data] : [...state.localData],
      }

    default:
      return state
  }
}

export interface AllCompanionListType {
  data: any
  loading: boolean
}

export const allCompanionList = (
  state: AllCompanionListType = { data: null, loading: false },
  { type, data, loading },
) => {
  switch (type) {
    case FETCH_ALL_COMPANION_LIST:
      return { data, loading }
    default:
      return state
  }
}
